import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import { confirmation } from '../../helpers/notifications';
import { moveForm, fetchContainers } from './constants/handleForm';
import { sortByAlpha } from '../../helpers/sorters';

const FormMoverModal = ({
  viewMoverModal,
  closeMoverModal,
  form,
  setForms,
}) => {
  const [containers, setContainers] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const handleFetchContainers = async () => {
    let response = await fetchContainers();
    if (response.ok) setContainers(sortByAlpha(response.data, 'name'));
  };

  const handleMoveForm = async () => {
    if (!selectedContainer.id) return;
    let moved = await moveForm(form.id, selectedContainer.id);
    if (moved.ok) {
      setForms((forms) => forms.filter((f) => f.id != form.id));
      confirmation.acknowledge(
        function yesClicked() {
          closeMoverModal();
          window.location = `/manage/containers/${moved.data.id}`;
        },
        function noClicked() {
          closeMoverModal();
        },
        'Form moved successfully!',
        "Go to form's new container?"
      );
    }
  };

  useEffect(() => {
    handleFetchContainers();
  }, []);

  return (
    <Modal show={viewMoverModal} onClose={closeMoverModal}>
      <header>
        <h3>Relocate This Form</h3>
      </header>

      <div className='available-container-content'>
        <div className='container-list-wrapper'>
          <h4>Select a destination container:</h4>
          <ol className='container-list'>
            {containers.length > 0 ? (
              containers
                .filter((c) => c.id != form.container_id)
                .map((c) => {
                  return (
                    <li
                      key={c.id}
                      className={
                        selectedContainer?.id === c.id
                          ? `container-${c.id} selected`
                          : `container-${c.id}`
                      }
                      id={`container-${c.id}`}
                      onClick={() => setSelectedContainer(c)}
                    >
                      {c.name}
                    </li>
                  );
                })
            ) : (
              <li className='empty'>Loading available containers...</li>
            )}
          </ol>
        </div>

        <div className='flex-controls'>
          <button
            disabled={!selectedContainer}
            onClick={() => handleMoveForm(form.id, selectedContainer.id)}
          >
            Move Form
          </button>
          <button onClick={closeMoverModal} className='blue'>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FormMoverModal;
